<template>
  <div class="list-component">
    <div class="list">
      <form action="/">
        <van-search v-model="searchKey" placeholder="请输入搜索关键词" show-action shape="round" @search="onSearch"
          @cancel="onSearchCancel" />
      </form>

      <van-pull-refresh v-model="refreshing" @refresh="onLoad">
        <div style="min-height: 90vh">
          <div class="item" v-for="item in showList" :key="item.id">
            <van-panel :title="item.asset_describe" :desc="item.category_name" :status="item.Status">
              <div>
                <van-cell title="资产编码" :value="item.asset_num" :border="false" size="small" />
                <van-cell title="序列号" :value="item.sn" :border="false" size="small" />
                <van-cell title="存货号" :value="item.stock_number" :border="false" size="small" />
                <van-cell title="管理单位" :value="item.management" :border="false" size="small" />
                <van-cell title="标签状况" :value="item.label" :border="false" size="small" />
              </div>
              <div slot="footer" class="item_footer">
                <van-button v-if="item.stock_status == '待盘点' && listType == 'mine'" type="primary" size="small" round
                  @click="gotoStock(item.id, '待盘点')">{{ $t("message.stock") }}
                </van-button>
                <van-button v-if="item.stock_status == '已盘点' && listType == 'mine'" type="primary" size="small"
                  @click="gotoStock(item.id, '已盘点')" round>{{ $t("message.stocked") }}
                </van-button>
                <van-button v-if="item.supervisor_status == '已监盘' && listType == 'mineJP'" type="primary" size="small"
                  @click="gotoStock(item.id, '已监盘')" round>{{ $t("message.supervisored") }}
                </van-button>
                <van-button v-if="item.supervisor_status == '待监盘' && listType == 'mineJP'" type="primary" size="small"
                  @click="gotoStock(item.id, '待监盘')" round>{{ $t("message.supervisor") }}
                </van-button>
                <van-button type="primary" size="small" round class="stock-btn" @click="showItemDetail(item)">{{
                $t("message.details") }}
                </van-button>
              </div>
            </van-panel>
          </div>
          <!-- 资产详情 -->
          <van-popup v-model="showDetails" @close="closeDetails" position="right" class="detail-container" lock-scroll>
            <van-cell :title="$t('message.assetDetails')" title-class="detail-title" size="large" />

            <van-cell title="资产编码" :value="listItem.asset_num" :border="false" class="detail-item" size="small" />
            <van-cell title="资产描述" :value="listItem.asset_describe" :border="false" class="detail-item" size="small" />
            <van-cell title="类型名" :value="listItem.category_name" :border="false" class="detail-item" size="small" />
            <van-cell title="序列号" :value="listItem.sn" :border="false" class="detail-item" size="small" />
            <van-cell title="盘点计划" :value="listItem.stock_p" :border="false" class="detail-item" size="small" />
            <van-cell title="盘点名称" :value="listItem.stock_name" :border="false" class="detail-item" size="small" />
            <van-cell title="存货号" :value="listItem.stock_number" :border="false" class="detail-item" size="small" />
            <van-cell title="正确存货号" :value="listItem.true_number" :border="false" class="detail-item" size="small" />
            <van-cell title="管理单位" :value="listItem.management" :border="false" class="detail-item" size="small" />
            <van-cell title="正确管理单位" :value="listItem.true_management" :border="false" class="detail-item" size="small" />
            <van-cell title="资产状态" :value="listItem.Status" :border="false" class="detail-item" size="small" />
            <van-cell title="标签状况" :value="listItem.label" :border="false" class="detail-item" size="small" />
          </van-popup>

        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {
  Search,
  List,
  PullRefresh,
  Dialog,
  Panel,
  CellGroup,
  Cell,
  Button,
  Popup,
  Icon,
  Toast,
} from "vant";

export default {
  name: "list",
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    Toast,
  },
  props: {
    type: String,
  },
  data() {
    return {
      searchKey: "",
      refreshing: false,
      resultList: [],
      showList: [],
      listType: "mine",
      showDetails: false,
      listItem: ''
    };
  },
  watch: {
    type: {
      handler(val) {
        if (val) {
          if (val.indexOf('盘点') > -1) {
            this.listType = 'mine'
          } else if (val.indexOf('监盘') > -1) {
            this.listType = 'mineJP'
          }
          this.onLoad();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.listType = this.$route.name || 'mine'
  },
  methods: {
    showItemDetail(item) {
      this.listItem = item
      this.showDetails = true
    },

    onSearch() {
      let that = this
      if (!this.resultList || this.resultList.length == 0) {
        return;
      } else {
        this.showList = [];
        this.resultList.forEach((re) => {
          if (JSON.stringify(re).includes(that.searchKey))
            this.showList.push(re);
        });
      }
    },
    onSearchCancel() {
      this.showList = this.resultList;
    },
    onLoad() {
      let that = this;
      if (this.refreshing) {
        this.resultList = [];
        this.refreshing = false;
      }

      this.$axios
        .get("device/" + this.listType)
        .then((res) => {

          if (that.listType == 'mine') {
            that.showList = that.resultList = res.filter(
              (item) => item.stock_status == that.type
            );
          } else if (that.listType == 'mineJP') {
            that.showList = that.resultList = res.filter(
              (item) => item.supervisor_status == that.type
            );
          }
          console.log("showList", that.showList)
        })
        .catch((res) => {
          Dialog.alert({
            title: "获取资产列表失败",
            message: res,
          }).then(() => {
            this.loading = false;
          });
        });
    },
    gotoStock(id, action) {
      console.log('-----调转接口----', action)
      this.$router.push({
        name: "yearStock",
        query: { id: id, action: action },
      });
    },
    closeDetails() {
      this.showDetails = false;
    },
  },
};
</script>
<style lang="less" scoped>
.list {
  background-color: #f7f8fa;

  .card {}

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 40px;
  }

  &-submit {
    text-align: center;

    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}

.detail-container {
    height: 70vh;
    width: 75%;
    margin: 8px 15px;
  }
.item {
  margin: 8px 15px;

  .item_footer {
    text-align: right;

    button {
      width: 60px;
      margin-left: 10px;
    }
  }

  

  .detail-close {
    text-align: center;
    font-size: 35px;
    position: fixed;
    bottom: 0;
  }

  .detail-close-btn {
    font-size: 35px;
    position: fixed;
    bottom: 30px;
  }
}
</style>
